import api from '../services/api';

export default async function putService(url,json) {

  return api
    .put(url, json,
    {
      headers: { 'Content-Type': 'application/json', },
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {
        type: 'error',
        data: error.response?.data || {detail: 'Não foi possível comunicar com o servidor.'},
      }
    });
}
